<template>
    <div class="cc-custom-message p-3" v-if="customMessageActive">
      <div v-html="customMessage"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                customMessageActive: state => state.config.custom_message_active,
                customMessage: state => state.config.custom_message,
            }),
        },
    };
</script>
